export default __webpack_public_path__ + "static/media/hashtag.6255f66c.svg";